import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, inject, RendererFactory2, EventEmitter, numberAttribute, booleanAttribute, forwardRef, Component, ViewEncapsulation, Input, Output, ViewChild, HostListener, Directive, HostBinding, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { FormControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import dayjs from 'dayjs/esm';
import localeData from 'dayjs/esm/plugin/localeData';
import LocalizedFormat from 'dayjs/esm/plugin/localizedFormat';
import isoWeek from 'dayjs/esm/plugin/isoWeek';
import week from 'dayjs/esm/plugin/weekOfYear';
import customParseFormat from 'dayjs/esm/plugin/customParseFormat';
import { DOCUMENT, NgClass, NgIf, NgForOf } from '@angular/common';
const _c0 = ["pickerContainer"];
const _c1 = (a0, a1, a2, a3, a4, a5, a6) => ({
  ltr: a0,
  rtl: a1,
  shown: a2,
  hidden: a3,
  inline: a4,
  double: a5,
  "show-ranges": a6
});
const _c2 = a0 => ({
  active: a0
});
const _c3 = (a0, a1) => ({
  right: a0,
  left: a1
});
const _c4 = () => [];
const _c5 = a0 => ({
  center: a0
});
function DaterangepickerComponent_div_3_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 11);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_3_li_2_Template_button_click_1_listener($event) {
      const range_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickRange($event, range_r2));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const range_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.disableRange(range_r2))("ngClass", i0.ɵɵpureFunction1(3, _c2, range_r2 === ctx_r2.chosenRange));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", range_r2, " ");
  }
}
function DaterangepickerComponent_div_3_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_3_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickOngoing());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(3, _c2, ctx_r2.isOngoingActive));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.locale.ongoingLabel, " ");
  }
}
function DaterangepickerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ul");
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_3_li_2_Template, 3, 5, "li", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_3_button_3_Template, 2, 5, "button", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.rangesArray);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.rangeWithOngoingButton);
  }
}
function DaterangepickerComponent_div_4_table_2_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 24);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_4_table_2_ng_container_4_Template_th_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickPrev(ctx_r2.sideEnum.left));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_7_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.inMinYear) && m_r7 < (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].minDate == null ? null : ctx_r2.calendarVariables["left"].minDate.month()) || (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.inMaxYear) && m_r7 > (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].maxDate == null ? null : ctx_r2.calendarVariables["left"].maxDate.month()))("value", m_r7)("selected", (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.currentMonth) === m_r7);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.locale.monthNames == null ? null : ctx_r2.locale.monthNames[m_r7], " ");
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_7_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r8 === (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.currentYear));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", y_r8, " ");
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25)(2, "div", 26)(3, "select", 27);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_4_table_2_ng_container_7_Template_select_change_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.monthChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_4_table_2_ng_container_7_option_4_Template, 2, 4, "option", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 26)(6, "select", 29);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_4_table_2_ng_container_7_Template_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.yearChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_4_table_2_ng_container_7_option_7_Template, 2, 2, "option", 30);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.monthArrays) || i0.ɵɵpureFunction0(2, _c4));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns == null ? null : ctx_r2.calendarVariables["left"].dropdowns.yearArrays) || i0.ɵɵpureFunction0(3, _c4));
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r2.locale.monthNames[(ctx_r2.calendarVariables == null ? null : ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar[1] == null ? null : ctx_r2.calendarVariables["left"].calendar[1][1] == null ? null : ctx_r2.calendarVariables["left"].calendar[1][1].month()) || -1], " ", ctx_r2.calendarVariables == null ? null : ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar[1] == null ? null : ctx_r2.calendarVariables["left"].calendar[1][1] == null ? null : ctx_r2.calendarVariables["left"].calendar[1][1].format(" YYYY"), " ");
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 33);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_4_table_2_ng_container_9_Template_th_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickNext(ctx_r2.sideEnum.left));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_4_table_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_4_table_2_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.locale.weekLabel);
  }
}
function DaterangepickerComponent_div_4_table_2_th_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dayofweek_r10 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r10);
  }
}
function DaterangepickerComponent_div_4_table_2_tr_15_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][0] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][0].week());
  }
}
function DaterangepickerComponent_div_4_table_2_tr_15_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][0] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][0].isoWeek());
  }
}
function DaterangepickerComponent_div_4_table_2_tr_15_td_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 36);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_4_table_2_tr_15_td_3_Template_td_click_0_listener($event) {
      const col_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const row_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickDate($event, ctx_r2.sideEnum.left, row_r11, col_r13));
    })("mouseenter", function DaterangepickerComponent_div_4_table_2_tr_15_td_3_Template_td_mouseenter_0_listener($event) {
      const col_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const row_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.hoverDate($event, ctx_r2.sideEnum.left, row_r11, col_r13));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r13 = ctx.$implicit;
    const row_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap((ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].classes == null ? null : ctx_r2.calendarVariables["left"].classes[row_r11] == null ? null : ctx_r2.calendarVariables["left"].classes[row_r11][col_r13]) || "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][col_r13] == null ? null : ctx_r2.calendarVariables["left"].calendar[row_r11][col_r13].date());
  }
}
function DaterangepickerComponent_div_4_table_2_tr_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_4_table_2_tr_15_td_1_Template, 3, 1, "td", 21)(2, DaterangepickerComponent_div_4_table_2_tr_15_td_2_Template, 3, 1, "td", 21)(3, DaterangepickerComponent_div_4_table_2_tr_15_td_3_Template, 3, 3, "td", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap((ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].classes == null ? null : ctx_r2.calendarVariables["left"].classes[row_r11] == null ? null : ctx_r2.calendarVariables["left"].classes[row_r11].classList) || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calCols);
  }
}
function DaterangepickerComponent_div_4_table_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 17)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_4_table_2_th_3_Template, 1, 0, "th", 18)(4, DaterangepickerComponent_div_4_table_2_ng_container_4_Template, 2, 0, "ng-container", 18)(5, DaterangepickerComponent_div_4_table_2_ng_container_5_Template, 2, 0, "ng-container", 18);
    i0.ɵɵelementStart(6, "th", 19);
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_4_table_2_ng_container_7_Template, 8, 4, "ng-container", 18)(8, DaterangepickerComponent_div_4_table_2_ng_container_8_Template, 2, 2, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_4_table_2_ng_container_9_Template, 2, 0, "ng-container", 18)(10, DaterangepickerComponent_div_4_table_2_ng_container_10_Template, 2, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 20);
    i0.ɵɵtemplate(12, DaterangepickerComponent_div_4_table_2_th_12_Template, 3, 1, "th", 21)(13, DaterangepickerComponent_div_4_table_2_th_13_Template, 3, 1, "th", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "tbody", 22);
    i0.ɵɵtemplate(15, DaterangepickerComponent_div_4_table_2_tr_15_Template, 4, 5, "tr", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers || ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].minDate) || (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].minDate == null ? null : ctx_r2.calendarVariables["left"].minDate.isBefore(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar.firstDay.subtract(1, "days"))) && (!ctx_r2.linkedCalendars || true));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(!(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].minDate) || (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].minDate == null ? null : ctx_r2.calendarVariables["left"].minDate.isBefore(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar.firstDay.subtract(1, "days"))) && (!ctx_r2.linkedCalendars || true)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDropdowns && (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.showDropdowns || !(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].dropdowns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].maxDate) || (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].maxDate == null ? null : ctx_r2.calendarVariables["left"].maxDate.isAfter(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar.lastDay.add(1, "days")))) && (!ctx_r2.linkedCalendars || ctx_r2.singleDatePicker));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !((!(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].maxDate) || (ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].maxDate == null ? null : ctx_r2.calendarVariables["left"].maxDate.isAfter(ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calendar == null ? null : ctx_r2.calendarVariables["left"].calendar.lastDay.add(1, "days")))) && (!ctx_r2.linkedCalendars || ctx_r2.singleDatePicker)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers || ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.locale.daysOfWeek);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["left"] == null ? null : ctx_r2.calendarVariables["left"].calRows);
  }
}
function DaterangepickerComponent_div_4_div_3_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r15 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r15)("disabled", (ctx_r2.timepickerVariables["left"] == null ? null : ctx_r2.timepickerVariables["left"].disabledHours.indexOf(i_r15)) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["left"] == null ? null : ctx_r2.timepickerVariables["left"].hoursLabels[i_r15], " ");
  }
}
function DaterangepickerComponent_div_4_div_3_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r16 = ctx.$implicit;
    const index_r17 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r16)("disabled", ctx_r2.timepickerVariables["left"].disabledMinutes.indexOf(i_r16) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["left"].minutesLabel[index_r17], " ");
  }
}
function DaterangepickerComponent_div_4_div_3_ng_container_9_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r19 = ctx.$implicit;
    const index_r20 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r19)("disabled", ctx_r2.timepickerVariables["left"].disabledSeconds.indexOf(i_r19) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["left"].secondsLabel[index_r20], " ");
  }
}
function DaterangepickerComponent_div_4_div_3_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 40);
    i0.ɵɵtext(2, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26)(4, "select", 44);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_4_div_3_ng_container_9_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["left"].selectedSecond, $event) || (ctx_r2.timepickerVariables["left"].selectedSecond = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_4_div_3_ng_container_9_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵtemplate(5, DaterangepickerComponent_div_4_div_3_ng_container_9_option_5_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["left"].selectedSecond);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.timepickerVariables["left"].seconds);
  }
}
function DaterangepickerComponent_div_4_div_3_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "select", 45);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_4_div_3_div_10_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["left"].ampmModel, $event) || (ctx_r2.timepickerVariables["left"].ampmModel = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_4_div_3_div_10_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵelementStart(2, "option", 46);
    i0.ɵɵtext(3, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option", 47);
    i0.ɵɵtext(5, "PM");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["left"].ampmModel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.timepickerVariables["left"].amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.timepickerVariables["left"].pmDisabled);
  }
}
function DaterangepickerComponent_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "div", 26)(2, "select", 38);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_4_div_3_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["left"].selectedHour, $event) || (ctx_r2.timepickerVariables["left"].selectedHour = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_4_div_3_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_4_div_3_option_3_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 40);
    i0.ɵɵtext(5, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 26)(7, "select", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_4_div_3_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["left"].selectedMinute, $event) || (ctx_r2.timepickerVariables["left"].selectedMinute = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_4_div_3_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.left));
    });
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_4_div_3_option_8_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_4_div_3_ng_container_9_Template, 6, 3, "ng-container", 18)(10, DaterangepickerComponent_div_4_div_3_div_10_Template, 6, 3, "div", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c5, ctx_r2.singleDatePicker));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["left"].selectedHour);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", (ctx_r2.timepickerVariables["left"] == null ? null : ctx_r2.timepickerVariables["left"].hours) || i0.ɵɵpureFunction0(11, _c4));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["left"].selectedMinute);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", (ctx_r2.timepickerVariables["left"] == null ? null : ctx_r2.timepickerVariables["left"].minutes) || i0.ɵɵpureFunction0(12, _c4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.timePickerSeconds);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.timePicker24Hour);
  }
}
function DaterangepickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_4_table_2_Template, 16, 10, "table", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_4_div_3_Template, 11, 13, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c3, ctx_r2.singleDatePicker, !ctx_r2.singleDatePicker));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.calendarVariables);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.timePicker);
  }
}
function DaterangepickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 48);
  }
}
function DaterangepickerComponent_div_6_table_2_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th");
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 24);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_6_table_2_ng_container_4_Template_th_click_1_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickPrev(ctx_r2.sideEnum.right));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_7_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r24 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.inMinYear) && (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate) && m_r24 < (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate.month()) || (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.inMaxYear) && (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate) && m_r24 > (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate.month()))("value", m_r24)("selected", (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.currentMonth) === m_r24);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.locale.monthNames == null ? null : ctx_r2.locale.monthNames[m_r24], " ");
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_7_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r25 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selected", y_r25 === (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.currentYear));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", y_r25, " ");
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25)(2, "div", 26)(3, "select", 27);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_6_table_2_ng_container_7_Template_select_change_3_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.monthChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵtemplate(4, DaterangepickerComponent_div_6_table_2_ng_container_7_option_4_Template, 2, 4, "option", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 26)(6, "select", 29);
    i0.ɵɵlistener("change", function DaterangepickerComponent_div_6_table_2_ng_container_7_Template_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r23);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.yearChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_6_table_2_ng_container_7_option_7_Template, 2, 2, "option", 30);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.monthArrays);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns.yearArrays);
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r2.locale.monthNames[ctx_r2.calendarVariables == null ? null : ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar[1] == null ? null : ctx_r2.calendarVariables["right"].calendar[1][1] == null ? null : ctx_r2.calendarVariables["right"].calendar[1][1].month()], " ", ctx_r2.calendarVariables == null ? null : ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar[1] == null ? null : ctx_r2.calendarVariables["right"].calendar[1][1] == null ? null : ctx_r2.calendarVariables["right"].calendar[1][1].format(" YYYY"), " ");
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 33);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_6_table_2_ng_container_9_Template_th_click_1_listener() {
      i0.ɵɵrestoreView(_r26);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickNext(ctx_r2.sideEnum.right));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_6_table_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "th");
    i0.ɵɵelementContainerEnd();
  }
}
function DaterangepickerComponent_div_6_table_2_th_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.locale.weekLabel);
  }
}
function DaterangepickerComponent_div_6_table_2_th_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dayofweek_r27 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dayofweek_r27);
  }
}
function DaterangepickerComponent_div_6_table_2_tr_15_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][0] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][0].week());
  }
}
function DaterangepickerComponent_div_6_table_2_tr_15_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][0] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][0].isoWeek());
  }
}
function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 36);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template_td_click_0_listener($event) {
      const col_r30 = i0.ɵɵrestoreView(_r29).$implicit;
      const row_r28 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickDate($event, ctx_r2.sideEnum.right, row_r28, col_r30));
    })("mouseenter", function DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template_td_mouseenter_0_listener($event) {
      const col_r30 = i0.ɵɵrestoreView(_r29).$implicit;
      const row_r28 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.hoverDate($event, ctx_r2.sideEnum.right, row_r28, col_r30));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r30 = ctx.$implicit;
    const row_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].classes[row_r28][col_r30]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][col_r30] == null ? null : ctx_r2.calendarVariables["right"].calendar[row_r28][col_r30].date());
  }
}
function DaterangepickerComponent_div_6_table_2_tr_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_6_table_2_tr_15_td_1_Template, 3, 1, "td", 21)(2, DaterangepickerComponent_div_6_table_2_tr_15_td_2_Template, 3, 1, "td", 21)(3, DaterangepickerComponent_div_6_table_2_tr_15_td_3_Template, 3, 3, "td", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r28 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].classes[row_r28].classList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calCols);
  }
}
function DaterangepickerComponent_div_6_table_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 17)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_table_2_th_3_Template, 1, 0, "th", 18)(4, DaterangepickerComponent_div_6_table_2_ng_container_4_Template, 2, 0, "ng-container", 18)(5, DaterangepickerComponent_div_6_table_2_ng_container_5_Template, 2, 0, "ng-container", 18);
    i0.ɵɵelementStart(6, "th", 51);
    i0.ɵɵtemplate(7, DaterangepickerComponent_div_6_table_2_ng_container_7_Template, 8, 2, "ng-container", 18)(8, DaterangepickerComponent_div_6_table_2_ng_container_8_Template, 2, 2, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_6_table_2_ng_container_9_Template, 2, 0, "ng-container", 18)(10, DaterangepickerComponent_div_6_table_2_ng_container_10_Template, 2, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tr", 20);
    i0.ɵɵtemplate(12, DaterangepickerComponent_div_6_table_2_th_12_Template, 3, 1, "th", 21)(13, DaterangepickerComponent_div_6_table_2_th_13_Template, 3, 1, "th", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, DaterangepickerComponent_div_6_table_2_tr_15_Template, 4, 5, "tr", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers || ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (!(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate) || (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate.isBefore(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar.firstDay.subtract(1, "days")))) && !ctx_r2.linkedCalendars);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !((!(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate) || (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].minDate.isBefore(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar.firstDay.subtract(1, "days")))) && !ctx_r2.linkedCalendars));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDropdowns && (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.showDropdowns || !(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].dropdowns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate) || (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate.isAfter(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar.lastDay.add(1, "days"))) && (!ctx_r2.linkedCalendars || ctx_r2.singleDatePicker || true));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(!(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate) || (ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].maxDate.isAfter(ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calendar == null ? null : ctx_r2.calendarVariables["right"].calendar.lastDay.add(1, "days"))) && (!ctx_r2.linkedCalendars || ctx_r2.singleDatePicker || true)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showWeekNumbers || ctx_r2.showISOWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.locale.daysOfWeek);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.calendarVariables["right"] == null ? null : ctx_r2.calendarVariables["right"].calRows);
  }
}
function DaterangepickerComponent_div_6_div_3_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r32 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r32)("disabled", (ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].disabledHours.indexOf(i_r32)) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].hoursLabels[i_r32], " ");
  }
}
function DaterangepickerComponent_div_6_div_3_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r33 = ctx.$implicit;
    const index_r34 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", i_r33)("disabled", (ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].disabledMinutes.indexOf(i_r33)) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].minutesLabel[index_r34], " ");
  }
}
function DaterangepickerComponent_div_6_div_3_ng_container_9_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r36 = ctx.$implicit;
    const index_r37 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", i_r36)("disabled", (ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].disabledSeconds.indexOf(i_r36)) > -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].secondsLabel[index_r37], " ");
  }
}
function DaterangepickerComponent_div_6_div_3_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 40);
    i0.ɵɵtext(2, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 26)(4, "select", 44);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_6_div_3_ng_container_9_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["right"].selectedSecond, $event) || (ctx_r2.timepickerVariables["right"].selectedSecond = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_ng_container_9_Template_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r35);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵtemplate(5, DaterangepickerComponent_div_6_div_3_ng_container_9_option_5_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["right"].selectedSecond);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].seconds);
  }
}
function DaterangepickerComponent_div_6_div_3_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "select", 45);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_6_div_3_div_10_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r38);
      const ctx_r2 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["right"].ampmModel, $event) || (ctx_r2.timepickerVariables["right"].ampmModel = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_div_10_Template_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r38);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵelementStart(2, "option", 46);
    i0.ɵɵtext(3, "AM");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option", 47);
    i0.ɵɵtext(5, "PM");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["right"].ampmModel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.timepickerVariables["right"].amDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.timepickerVariables["right"].pmDisabled);
  }
}
function DaterangepickerComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52)(1, "div", 26)(2, "select", 53);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["right"].selectedHour, $event) || (ctx_r2.timepickerVariables["right"].selectedHour = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_div_3_option_3_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 40);
    i0.ɵɵtext(5, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 26)(7, "select", 41);
    i0.ɵɵtwoWayListener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r2.timepickerVariables["right"].selectedMinute, $event) || (ctx_r2.timepickerVariables["right"].selectedMinute = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function DaterangepickerComponent_div_6_div_3_Template_select_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.timeChanged($event, ctx_r2.sideEnum.right));
    });
    i0.ɵɵtemplate(8, DaterangepickerComponent_div_6_div_3_option_8_Template, 2, 3, "option", 39);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, DaterangepickerComponent_div_6_div_3_ng_container_9_Template, 6, 3, "ng-container", 18)(10, DaterangepickerComponent_div_6_div_3_div_10_Template, 6, 3, "div", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["right"].selectedHour);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].hours);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !ctx_r2.startDate);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timepickerVariables["right"].selectedMinute);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.timepickerVariables["right"] == null ? null : ctx_r2.timepickerVariables["right"].minutes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.timePickerSeconds);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.timePicker24Hour);
  }
}
function DaterangepickerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49)(1, "div", 14);
    i0.ɵɵtemplate(2, DaterangepickerComponent_div_6_table_2_Template, 16, 10, "table", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DaterangepickerComponent_div_6_div_3_Template, 11, 8, "div", 50);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.calendarVariables);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.timePicker);
  }
}
function DaterangepickerComponent_div_7_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 58);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_7_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r40);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clear());
    });
    i0.ɵɵtext(1);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 59);
    i0.ɵɵelement(3, "path", 60);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r2.locale.clearLabel);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.locale.clearLabel, " ");
  }
}
function DaterangepickerComponent_div_7_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 61);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_7_button_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r41);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clickCancel($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.locale.cancelLabel, " ");
  }
}
function DaterangepickerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, DaterangepickerComponent_div_7_button_1_Template, 4, 2, "button", 55)(2, DaterangepickerComponent_div_7_button_2_Template, 2, 1, "button", 56);
    i0.ɵɵelementStart(3, "button", 57);
    i0.ɵɵlistener("click", function DaterangepickerComponent_div_7_Template_button_click_3_listener($event) {
      i0.ɵɵrestoreView(_r39);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clickApply($event));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showClearButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showCancel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.applyBtn.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.locale.applyLabel, " ");
  }
}
dayjs.extend(localeData);
const LOCALE_CONFIG = new InjectionToken('daterangepicker.config');
const THEME_CONFIG = new InjectionToken('daterangepicker.config');
const DefaultLocaleConfig = {
  direction: 'ltr',
  separator: ' - ',
  weekLabel: 'W',
  applyLabel: 'Apply',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  customRangeLabel: 'Custom range',
  ongoingLabel: 'Ongoing',
  daysOfWeek: dayjs.weekdaysMin(),
  monthNames: dayjs.monthsShort(),
  firstDay: dayjs.localeData().firstDayOfWeek()
};
const DefaultThemeConfig = {
  color: 'inherit',
  bgColor: '#fff',
  inRangeColor: '#5A5A5A',
  inRangeBorderColor: 'transparent',
  inRangeBgColor: '#FAFAFA',
  inRangeFontWeight: '600',
  activeColor: '#ffffff',
  activeBgColor: '#151F6D',
  activeBorderColor: 'transparent',
  activeFontWeight: '600',
  unselectedColor: 'rgba(90, 90, 90, .5)',
  unselectedBorderColor: 'transparent',
  unselectedBgColor: '#fff',
  width: '278px',
  widthDouble: 'auto',
  borderColor: '#ccc',
  calendarMargin: '12px',
  calendarBgColor: '#fff',
  calendarBorderSize: '1px',
  calendarBorderColor: 'transparent',
  calendarBorderRadius: '4px',
  cellSize: '32px',
  cellHeight: '32px',
  cellWidth: '32px',
  cellBorderRadius: '4px',
  cellBorderSize: '1px',
  cellColor: '#5A5A5A',
  cellBorderColor: 'transparent',
  cellBgColor: '#fff',
  cellFontSize: '14px',
  cellFontWeight: '400',
  cellHoverColor: '#5A5A5A',
  cellHoverBorderColor: 'transparent',
  cellHoverBgColor: '#FAFAFA',
  cellHoverFontWeight: '600',
  cellWeekdayNameColor: '#5A5A5A',
  cellWeekdayNameFontWeight: '700',
  cellWeekdayNameFontSize: '12px',
  controlHeight: '30px',
  controlLineHeight: '30px',
  controlColor: '#555',
  controlBorderSize: '1px',
  controlBorderColor: '#ccc',
  controlBorderRadius: '4px',
  controlActiveBorderSize: '1px',
  controlActiveBorderColor: '#08c',
  controlActiveBorderRadius: '4px',
  controlDisabledColor: '#ccc',
  selectBorder: '1px solid #E8E8E8',
  selectBackground: '#ffffff',
  selectPadding: '0 8px',
  selectRadius: '4px',
  selectFontSize: '14px',
  selectColor: '#000000',
  inputHeight: '32px',
  separatorColor: '#E8E8E8',
  hoverCustomRangeBorderColor: '#BFBFBF'
};
let LocaleService = /*#__PURE__*/(() => {
  class LocaleService {
    configHolder;
    constructor(configHolder) {
      this.configHolder = configHolder;
    }
    get config() {
      if (!this.configHolder) {
        return DefaultLocaleConfig;
      }
      return {
        ...DefaultLocaleConfig,
        ...this.configHolder
      };
    }
    configWithLocale(locale) {
      if (!this.configHolder && !locale) {
        return DefaultLocaleConfig;
      }
      return {
        ...DefaultLocaleConfig,
        ...{
          daysOfWeek: locale.weekdaysMin,
          monthNames: locale.monthsShort,
          firstDay: locale.weekStart
        },
        ...this.configHolder
      };
    }
    static ɵfac = function LocaleService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocaleService)(i0.ɵɵinject(LOCALE_CONFIG));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocaleService,
      factory: LocaleService.ɵfac
    });
  }
  return LocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThemeService = /*#__PURE__*/(() => {
  class ThemeService {
    configHolder;
    document;
    renderer;
    rendererFactory = inject(RendererFactory2);
    constructor(configHolder, document) {
      this.configHolder = configHolder;
      this.document = document;
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    get themeConfig() {
      if (!this.configHolder) {
        return DefaultThemeConfig;
      }
      return {
        ...DefaultThemeConfig,
        ...this.configHolder
      };
    }
    setThemeToElement(element = this.document.documentElement) {
      Object.keys(this.themeConfig).forEach(item => {
        const variableName = `--datepicker-${item}`;
        const value = this.themeConfig[item];
        this.setCSSVariable(element, variableName, value);
      });
    }
    setCSSVariable(element, variableName, value) {
      element.style.setProperty(variableName, value);
      this.renderer.setStyle(element, variableName, value);
    }
    static ɵfac = function ThemeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThemeService)(i0.ɵɵinject(THEME_CONFIG), i0.ɵɵinject(DOCUMENT));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ThemeService,
      factory: ThemeService.ɵfac
    });
  }
  return ThemeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
dayjs.extend(localeData);
dayjs.extend(LocalizedFormat);
dayjs.extend(isoWeek);
dayjs.extend(week);
dayjs.extend(customParseFormat);
var SideEnum = /*#__PURE__*/function (SideEnum) {
  SideEnum["left"] = "left";
  SideEnum["right"] = "right";
  return SideEnum;
}(SideEnum || {});
let DaterangepickerComponent = /*#__PURE__*/(() => {
  class DaterangepickerComponent {
    el;
    ref;
    localeHolderService;
    themeHolderService;
    startDate = dayjs().startOf('day');
    endDate = dayjs().endOf('day');
    dateLimit;
    autoApply = false;
    singleDatePicker = false;
    showDropdowns = false;
    showWeekNumbers = false;
    showISOWeekNumbers = false;
    linkedCalendars = false;
    autoUpdateInput = true;
    alwaysShowCalendars = false;
    maxSpan = false;
    lockStartDate = false;
    timePicker = false;
    timePicker24Hour = false;
    timePickerIncrement = 1;
    timePickerSeconds = false;
    showClearButton = false;
    firstMonthDayClass;
    lastMonthDayClass;
    emptyWeekRowClass;
    emptyWeekColumnClass;
    firstDayOfNextMonthClass;
    lastDayOfPreviousMonthClass;
    showCustomRangeLabel;
    showCancel = false;
    keepCalendarOpeningWithRange = false;
    showRangeLabelOnInput = false;
    customRangeDirection = false;
    rangeWithOngoingButton = false;
    drops;
    opens;
    closeOnAutoApply = true;
    choosedDate;
    rangeClicked;
    datesUpdated;
    startDateChanged;
    endDateChanged;
    cancelClicked;
    clearClicked;
    ongoingChange = new EventEmitter();
    calendarShow = new EventEmitter();
    calendarHide = new EventEmitter();
    pickerContainer;
    chosenLabel;
    calendarVariables = {};
    timepickerVariables = {};
    daterangepicker = {
      start: new FormControl(),
      end: new FormControl()
    };
    applyBtn = {
      disabled: false
    };
    sideEnum = SideEnum;
    chosenRange;
    rangesArray = [];
    isShown = false;
    inline = true;
    leftCalendar = {
      month: null,
      calendar: []
    };
    rightCalendar = {
      month: null,
      calendar: []
    };
    showCalInRanges = false;
    nowHoveredDate = null;
    pickingDate = false;
    minDateHolder;
    maxDateHolder;
    localeHolder = {};
    rangesHolder = {};
    isOngoingActive = false;
    cachedVersion = {
      start: null,
      end: null
    };
    constructor(el, ref, localeHolderService, themeHolderService) {
      this.el = el;
      this.ref = ref;
      this.localeHolderService = localeHolderService;
      this.themeHolderService = themeHolderService;
      this.choosedDate = new EventEmitter();
      this.rangeClicked = new EventEmitter();
      this.datesUpdated = new EventEmitter();
      this.startDateChanged = new EventEmitter();
      this.endDateChanged = new EventEmitter();
      this.cancelClicked = new EventEmitter();
      this.clearClicked = new EventEmitter();
    }
    get minDate() {
      return this.minDateHolder;
    }
    set minDate(value) {
      if (dayjs.isDayjs(value)) {
        this.minDateHolder = value;
      } else if (typeof value === 'string') {
        this.minDateHolder = dayjs(value);
      } else {
        this.minDateHolder = null;
      }
    }
    get locale() {
      return this.localeHolder;
    }
    set locale(value) {
      this.localeHolder = {
        ...this.localeHolderService.config,
        ...value
      };
      if (value.locale) {
        this.localeHolder = this.localeHolderService.configWithLocale(value.locale);
      }
    }
    get ranges() {
      return this.rangesHolder;
    }
    set ranges(value) {
      this.rangesHolder = value;
      this.renderRanges();
    }
    get ongoing() {
      return this.isOngoingActive;
    }
    set ongoing(value) {
      this.isOngoingActive = value;
    }
    get maxDate() {
      return this.maxDateHolder;
    }
    set maxDate(value) {
      if (dayjs.isDayjs(value)) {
        this.maxDateHolder = value;
      } else if (typeof value === 'string') {
        this.maxDateHolder = dayjs(value);
      } else {
        this.maxDateHolder = null;
      }
    }
    isInvalidDate(date) {
      return false;
    }
    isCustomDate(date) {
      return false;
    }
    isTooltipDate(date) {
      return null;
    }
    handleInternalClick(e) {
      return e.stopPropagation();
    }
    ngAfterViewInit() {
      this.themeHolderService.setThemeToElement(this.el.nativeElement);
    }
    ngOnChanges(changes) {
      if ((changes.startDate || changes.endDate) && this.inline) {
        this.validateStartEndEndDate();
        this.updateView();
      }
    }
    ngOnInit() {
      this.buildLocale();
      const daysOfWeek = [...this.locale.daysOfWeek];
      this.locale.firstDay = this.locale.firstDay % 7;
      if (this.locale.firstDay !== 0) {
        let iterator = this.locale.firstDay;
        while (iterator > 0) {
          daysOfWeek.push(daysOfWeek.shift());
          iterator--;
        }
      }
      this.locale.daysOfWeek = daysOfWeek;
      if (this.inline) {
        this.cachedVersion.start = this.startDate.clone();
        this.cachedVersion.end = this.endDate.clone();
      }
      if (this.startDate && this.timePicker) {
        this.setStartDate(this.startDate);
        this.renderTimePicker(SideEnum.left);
      }
      if (this.endDate && this.timePicker) {
        this.setEndDate(this.endDate);
        this.renderTimePicker(SideEnum.right);
      }
      this.updateMonthsInView();
      this.renderCalendar(SideEnum.left);
      this.renderCalendar(SideEnum.right);
      this.renderRanges();
    }
    validateStartEndEndDate() {
      if (this.maxDate) {
        this.startDate.isAfter(this.maxDate) && (this.startDate = this.maxDate.clone());
        this.endDate.isAfter(this.maxDate) && (this.endDate = this.maxDate.clone());
      }
      if (this.minDate) {
        this.startDate.isBefore(this.minDate) && (this.startDate = this.minDate.clone());
        this.endDate.isBefore(this.minDate) && (this.endDate = this.minDate.clone());
      }
    }
    renderRanges() {
      this.rangesArray = [];
      let start;
      let end;
      if (typeof this.ranges === 'object') {
        for (const range in this.ranges) {
          if (this.ranges[range]) {
            if (typeof this.ranges[range][0] === 'string') {
              start = dayjs(this.ranges[range][0], this.locale.format);
            } else {
              start = dayjs(this.ranges[range][0]);
            }
            if (typeof this.ranges[range][1] === 'string') {
              end = dayjs(this.ranges[range][1], this.locale.format);
            } else {
              end = dayjs(this.ranges[range][1]);
            }
            if (this.minDate && start.isBefore(this.minDate)) {
              start = this.minDate.clone();
            }
            let maxDate = this.maxDate;
            if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) {
              maxDate = start.clone().add(this.maxSpan);
            }
            if (maxDate && end.isAfter(maxDate)) {
              end = maxDate.clone();
            }
            if (this.minDate && end.isBefore(this.minDate, this.timePicker ? 'minute' : 'day') || maxDate && start.isAfter(maxDate, this.timePicker ? 'minute' : 'day')) {
              continue;
            }
            const elem = document.createElement('textarea');
            elem.innerHTML = range;
            const rangeHtml = elem.value;
            this.ranges[rangeHtml] = [start, end];
          }
        }
        for (const range in this.ranges) {
          if (this.ranges[range]) {
            this.rangesArray.push(range);
          }
        }
        if (this.showCustomRangeLabel) {
          this.rangesArray.push(this.locale.customRangeLabel);
        }
        this.showCalInRanges = !this.rangesArray.length || this.alwaysShowCalendars;
        if (!this.timePicker) {
          this.startDate = this.startDate.startOf('day');
          this.endDate = this.endDate.endOf('day');
        }
      }
    }
    renderTimePicker(side) {
      let selected;
      let minDate;
      const maxDate = this.maxDate;
      if (side === SideEnum.left) {
        selected = this.startDate.clone();
        minDate = this.minDate;
      } else if (side === SideEnum.right && this.endDate) {
        selected = this.endDate.clone();
        minDate = this.startDate;
      } else if (side === SideEnum.right && !this.endDate) {
        selected = this.getDateWithTime(this.startDate, SideEnum.right);
        if (selected.isBefore(this.startDate)) {
          selected = this.startDate.clone();
        }
        minDate = this.startDate;
      }
      const start = this.timePicker24Hour ? 0 : 1;
      const end = this.timePicker24Hour ? 23 : 12;
      this.timepickerVariables[side] = {
        hours: [],
        hoursLabels: [],
        minutes: [],
        minutesLabel: [],
        seconds: [],
        secondsLabel: [],
        disabledHours: [],
        disabledMinutes: [],
        disabledSeconds: [],
        selectedHour: 0,
        selectedMinute: 0,
        selectedSecond: 0,
        selected
      };
      for (let i = start; i <= end; i++) {
        let iIn24 = i;
        if (!this.timePicker24Hour) {
          iIn24 = selected.hour() >= 12 ? i === 12 ? 12 : i + 12 : i === 12 ? 0 : i;
        }
        const time = selected.clone().hour(iIn24);
        let disabled = false;
        if (minDate && time.minute(59).isBefore(minDate)) {
          disabled = true;
        }
        if (maxDate && time.minute(0).isAfter(maxDate)) {
          disabled = true;
        }
        const hour = i < 10 ? `0${i}` : String(i);
        this.timepickerVariables[side].hours.push(i);
        this.timepickerVariables[side].hoursLabels.push(hour);
        if (iIn24 === selected.hour() && !disabled) {
          this.timepickerVariables[side].selectedHour = i;
        } else if (disabled) {
          this.timepickerVariables[side].disabledHours.push(i);
        }
      }
      for (let i = 0; i < 60; i += this.timePickerIncrement) {
        const padded = i < 10 ? `0${i}` : `${i}`;
        const time = selected.clone().minute(i);
        let disabled = false;
        if (minDate && time.second(59).isBefore(minDate)) {
          disabled = true;
        }
        if (maxDate && time.second(0).isAfter(maxDate)) {
          disabled = true;
        }
        this.timepickerVariables[side].minutes.push(i);
        this.timepickerVariables[side].minutesLabel.push(padded);
        if (selected.minute() === i && !disabled) {
          this.timepickerVariables[side].selectedMinute = i;
        } else if (disabled) {
          this.timepickerVariables[side].disabledMinutes.push(i);
        }
      }
      if (this.timePickerSeconds) {
        for (let i = 0; i < 60; i++) {
          const padded = i < 10 ? `0${i}` : `${i}`;
          const time = selected.clone().second(i);
          let disabled = false;
          if (minDate && time.isBefore(minDate)) {
            disabled = true;
          }
          if (maxDate && time.isAfter(maxDate)) {
            disabled = true;
          }
          this.timepickerVariables[side].seconds.push(i);
          this.timepickerVariables[side].secondsLabel.push(padded);
          if (selected.second() === i && !disabled) {
            this.timepickerVariables[side].selectedSecond = i;
          } else if (disabled) {
            this.timepickerVariables[side].disabledSeconds.push(i);
          }
        }
      }
      if (!this.timePicker24Hour) {
        if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) {
          this.timepickerVariables[side].amDisabled = true;
        }
        if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) {
          this.timepickerVariables[side].pmDisabled = true;
        }
        if (selected.hour() >= 12) {
          this.timepickerVariables[side].ampmModel = 'PM';
        } else {
          this.timepickerVariables[side].ampmModel = 'AM';
        }
      }
      this.timepickerVariables[side].selected = selected;
    }
    renderCalendar(side) {
      const mainCalendar = side === SideEnum.left ? this.leftCalendar : this.rightCalendar;
      const month = mainCalendar.month.month();
      const year = mainCalendar.month.year();
      const hour = mainCalendar.month.hour();
      const minute = mainCalendar.month.minute();
      const second = mainCalendar.month.second();
      const daysInMonth = dayjs(new Date(year, month)).daysInMonth();
      const firstDay = dayjs(new Date(year, month, 1));
      const lastDay = dayjs(new Date(year, month, daysInMonth));
      const lastMonth = dayjs(firstDay).subtract(1, 'month').month();
      const lastYear = dayjs(firstDay).subtract(1, 'month').year();
      const daysInLastMonth = dayjs(new Date(lastYear, lastMonth)).daysInMonth();
      const dayOfWeek = firstDay.day();
      const calendar = [];
      calendar.firstDay = firstDay;
      calendar.lastDay = lastDay;
      for (let i = 0; i < 6; i++) {
        calendar[i] = [];
      }
      let startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
      if (startDay > daysInLastMonth) {
        startDay -= 7;
      }
      if (dayOfWeek === this.locale.firstDay) {
        startDay = daysInLastMonth - 6;
      }
      let curDate = dayjs(new Date(lastYear, lastMonth, startDay, 12, minute, second));
      for (let i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = dayjs(curDate).add(24, 'hours')) {
        if (i > 0 && col % 7 === 0) {
          col = 0;
          row++;
        }
        calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
        curDate = curDate.hour(12);
        if (this.minDate && calendar[row][col].format('YYYY-MM-DD') === this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side === 'left') {
          calendar[row][col] = this.minDate.clone();
        }
        if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') === this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side === 'right') {
          calendar[row][col] = this.maxDate.clone();
        }
      }
      if (side === SideEnum.left) {
        this.leftCalendar.calendar = calendar;
      } else {
        this.rightCalendar.calendar = calendar;
      }
      let minDate = side === 'left' ? this.minDate : this.startDate;
      let maxDate = this.maxDate;
      if (this.endDate === null && this.dateLimit) {
        const maxLimit = this.startDate.clone().add(this.dateLimit, 'day').endOf('day');
        if (!maxDate || maxLimit.isBefore(maxDate)) {
          maxDate = maxLimit;
        }
        if (this.customRangeDirection) {
          minDate = this.minDate;
          const minLimit = this.startDate.clone().subtract(this.dateLimit, 'day').endOf('day');
          if (!minDate || minLimit.isAfter(minDate)) {
            minDate = minLimit;
          }
        }
      }
      this.calendarVariables[side] = {
        month,
        year,
        hour,
        minute,
        second,
        daysInMonth,
        firstDay,
        lastDay,
        lastMonth,
        lastYear,
        daysInLastMonth,
        dayOfWeek,
        calRows: Array.from(Array(6).keys()),
        calCols: Array.from(Array(7).keys()),
        classes: {},
        minDate,
        maxDate,
        calendar
      };
      if (this.showDropdowns) {
        const currentMonth = calendar[1][1].month();
        const currentYear = calendar[1][1].year();
        const realCurrentYear = dayjs().year();
        const maxYear = maxDate && maxDate.year() || realCurrentYear + 5;
        const minYear = minDate && minDate.year() || realCurrentYear - 50;
        const inMinYear = currentYear === minYear;
        const inMaxYear = currentYear === maxYear;
        const years = [];
        for (let y = minYear; y <= maxYear; y++) {
          years.push(y);
        }
        this.calendarVariables[side].dropdowns = {
          currentMonth,
          currentYear,
          maxYear,
          minYear,
          inMinYear,
          inMaxYear,
          monthArrays: Array.from(Array(12).keys()),
          yearArrays: years
        };
      }
      this.buildCells(calendar, side);
    }
    setStartDate(startDate) {
      if (typeof startDate === 'string') {
        this.startDate = dayjs(startDate, this.locale.format);
      }
      if (typeof startDate === 'object') {
        this.pickingDate = true;
        this.startDate = dayjs(startDate);
      }
      if (!this.timePicker) {
        this.pickingDate = true;
        this.startDate = this.startDate.startOf('day');
      }
      if (this.timePicker && this.timePickerIncrement) {
        this.startDate = this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
      }
      if (this.minDate && this.startDate.isBefore(this.minDate)) {
        this.startDate = this.minDate.clone();
        if (this.timePicker && this.timePickerIncrement) {
          this.startDate = this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
      }
      if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
        this.startDate = this.maxDate.clone();
        if (this.timePicker && this.timePickerIncrement) {
          this.startDate = this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
        }
      }
      if (!this.isShown) {
        this.updateElement();
      }
      this.startDateChanged.emit({
        startDate: this.startDate
      });
      this.updateMonthsInView();
    }
    setEndDate(endDate) {
      if (typeof endDate === 'string') {
        this.endDate = dayjs(endDate, this.locale.format);
      }
      if (typeof endDate === 'object') {
        this.pickingDate = false;
        this.endDate = dayjs(endDate);
      }
      if (!this.timePicker) {
        this.pickingDate = false;
        this.endDate = this.endDate.add(1, 'd').startOf('day').subtract(1, 'second');
      }
      if (this.timePicker && this.timePickerIncrement) {
        this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
      }
      if (this.endDate.isBefore(this.startDate)) {
        this.endDate = this.startDate.clone();
      }
      if (this.maxDate && this.endDate.isAfter(this.maxDate)) {
        this.endDate = this.maxDate.clone();
      }
      if (this.dateLimit && this.startDate.clone().add(this.dateLimit, 'day').isBefore(this.endDate)) {
        this.endDate = this.startDate.clone().add(this.dateLimit, 'day');
      }
      if (!this.isShown) {}
      this.endDateChanged.emit({
        endDate: this.endDate
      });
      this.updateMonthsInView();
    }
    updateView() {
      if (this.timePicker) {
        this.renderTimePicker(SideEnum.left);
        this.renderTimePicker(SideEnum.right);
      }
      this.updateMonthsInView();
      this.updateCalendars();
    }
    updateMonthsInView() {
      if (this.endDate) {
        if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate && this.leftCalendar && this.startDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.startDate && this.rightCalendar && this.startDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM')) && (this.endDate.format('YYYY-MM') === this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') === this.rightCalendar.month.format('YYYY-MM'))) {
          return;
        }
        if (this.startDate) {
          this.leftCalendar.month = this.startDate.clone().date(2);
          if (!this.linkedCalendars && (this.endDate.month() !== this.startDate.month() || this.endDate.year() !== this.startDate.year())) {
            this.rightCalendar.month = this.endDate.clone().date(2);
          } else {
            this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
          }
        }
      } else {
        if (this.leftCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') !== this.startDate.format('YYYY-MM')) {
          this.leftCalendar.month = this.startDate.clone().date(2);
          this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
        }
      }
      if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
        this.rightCalendar.month = this.maxDate.clone().date(2);
        this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
      }
    }
    updateCalendars() {
      this.renderCalendar(SideEnum.left);
      this.renderCalendar(SideEnum.right);
      if (this.endDate === null) {
        return;
      }
      this.calculateChosenLabel();
    }
    updateElement() {
      const format = this.locale.displayFormat ? this.locale.displayFormat : this.locale.format;
      if (!this.singleDatePicker && this.autoUpdateInput) {
        if (this.startDate && this.endDate) {
          if (this.rangesArray.length && this.showRangeLabelOnInput === true && this.chosenRange && this.locale.customRangeLabel !== this.chosenRange) {
            this.chosenLabel = this.chosenRange;
          } else {
            this.chosenLabel = this.startDate.format(format) + this.locale.separator + this.endDate.format(format);
          }
        }
      } else if (this.autoUpdateInput) {
        this.chosenLabel = this.startDate.format(format);
      }
    }
    remove() {
      this.isShown = false;
    }
    calculateChosenLabel() {
      if (!this.locale || !this.locale.separator) {
        this.buildLocale();
      }
      let customRange = true;
      let i = 0;
      if (this.rangesArray.length > 0) {
        for (const range in this.ranges) {
          if (this.ranges[range]) {
            if (this.timePicker) {
              const format = this.timePickerSeconds ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD HH:mm';
              if (this.startDate.format(format) === this.ranges[range][0].format(format) && this.endDate.format(format) === this.ranges[range][1].format(format)) {
                customRange = false;
                this.chosenRange = this.rangesArray[i];
                break;
              }
            } else {
              if (this.startDate.format('YYYY-MM-DD') === this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') === this.ranges[range][1].format('YYYY-MM-DD')) {
                customRange = false;
                this.chosenRange = this.rangesArray[i];
                break;
              }
            }
            i++;
          }
        }
        if (customRange) {
          if (this.showCustomRangeLabel) {
            this.chosenRange = this.locale.customRangeLabel;
          } else {
            this.chosenRange = null;
          }
          this.showCalInRanges = true;
        }
      }
      this.updateElement();
    }
    clickApply(e) {
      if (!this.singleDatePicker && this.startDate && !this.endDate) {
        if (this.timePicker) {
          this.endDate = this.getDateWithTime(this.startDate, SideEnum.right);
        } else {
          this.endDate = this.startDate.clone();
        }
        this.calculateChosenLabel();
      }
      if (this.isInvalidDate && this.startDate && this.endDate) {
        let d = this.startDate.clone();
        while (d.isBefore(this.endDate)) {
          if (this.isInvalidDate(d)) {
            this.endDate = d.subtract(1, 'days');
            this.calculateChosenLabel();
            break;
          }
          d = d.add(1, 'days');
        }
      }
      if (this.chosenLabel) {
        this.choosedDate.emit({
          chosenLabel: this.chosenLabel,
          startDate: this.startDate,
          endDate: this.endDate
        });
      }
      this.datesUpdated.emit({
        startDate: this.startDate,
        endDate: this.endDate
      });
      if (e || this.closeOnAutoApply && !e) {
        this.hide();
      }
    }
    clickCancel(e) {
      this.startDate = this.cachedVersion.start;
      this.endDate = this.cachedVersion.end;
      if (this.inline) {
        this.updateView();
      }
      this.cancelClicked.emit();
      this.hide();
    }
    monthChanged(monthEvent, side) {
      const year = this.calendarVariables[side].dropdowns.currentYear;
      const month = parseInt(monthEvent.target.value, 10);
      this.monthOrYearChanged(month, year, side);
    }
    yearChanged(yearEvent, side) {
      const month = this.calendarVariables[side].dropdowns.currentMonth;
      const year = parseInt(yearEvent.target.value, 10);
      this.monthOrYearChanged(month, year, side);
    }
    timeChanged(timeEvent, side) {
      let hour = parseInt(String(this.timepickerVariables[side].selectedHour), 10);
      const minute = parseInt(String(this.timepickerVariables[side].selectedMinute), 10);
      const second = this.timePickerSeconds ? parseInt(String(this.timepickerVariables[side].selectedSecond), 10) : 0;
      if (!this.timePicker24Hour) {
        const ampm = this.timepickerVariables[side].ampmModel;
        if (ampm === 'PM' && hour < 12) {
          hour += 12;
        }
        if (ampm === 'AM' && hour === 12) {
          hour = 0;
        }
      }
      if (side === SideEnum.left) {
        let start = this.startDate.clone();
        start = start.hour(hour);
        start = start.minute(minute);
        start = start.second(second);
        this.setStartDate(start);
        if (this.singleDatePicker) {
          this.endDate = this.startDate.clone();
        } else if (this.endDate && this.endDate.format('YYYY-MM-DD') === start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
          this.setEndDate(start.clone());
        } else if (!this.endDate && this.timePicker) {
          const startClone = this.getDateWithTime(start, SideEnum.right);
          if (startClone.isBefore(start)) {
            this.timepickerVariables[SideEnum.right].selectedHour = hour;
            this.timepickerVariables[SideEnum.right].selectedMinute = minute;
            this.timepickerVariables[SideEnum.right].selectedSecond = second;
          }
        }
      } else if (this.endDate) {
        let end = this.endDate.clone();
        end = end.hour(hour);
        end = end.minute(minute);
        end = end.second(second);
        this.setEndDate(end);
      }
      this.updateCalendars();
      this.renderTimePicker(SideEnum.left);
      this.renderTimePicker(SideEnum.right);
      if (this.autoApply) {
        this.clickApply();
      }
    }
    monthOrYearChanged(month, year, side) {
      const isLeft = side === SideEnum.left;
      let newMonth = month;
      let newYear = year;
      if (!isLeft) {
        if (newYear < this.startDate.year() || newYear === this.startDate.year() && newMonth < this.startDate.month()) {
          newMonth = this.startDate.month();
          newYear = this.startDate.year();
        }
      }
      if (this.minDate) {
        if (newYear < this.minDate.year() || newYear === this.minDate.year() && newMonth < this.minDate.month()) {
          newMonth = this.minDate.month();
          newYear = this.minDate.year();
        }
      }
      if (this.maxDate) {
        if (newYear > this.maxDate.year() || newYear === this.maxDate.year() && newMonth > this.maxDate.month()) {
          newMonth = this.maxDate.month();
          newYear = this.maxDate.year();
        }
      }
      this.calendarVariables[side].dropdowns.currentYear = newYear;
      this.calendarVariables[side].dropdowns.currentMonth = newMonth;
      if (isLeft) {
        this.leftCalendar.month = this.leftCalendar.month.month(newMonth).year(newYear);
        if (this.linkedCalendars) {
          this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
        }
      } else {
        this.rightCalendar.month = this.rightCalendar.month.month(newMonth).year(newYear);
        if (this.linkedCalendars) {
          this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
        }
      }
      this.updateCalendars();
    }
    clickPrev(side) {
      if (side === SideEnum.left) {
        this.leftCalendar.month = this.leftCalendar.month.subtract(1, 'month');
        if (this.linkedCalendars) {
          this.rightCalendar.month = this.rightCalendar.month.subtract(1, 'month');
        }
      } else {
        this.rightCalendar.month = this.rightCalendar.month.subtract(1, 'month');
      }
      this.updateCalendars();
    }
    clickNext = side => {
      if (side === SideEnum.left) {
        this.leftCalendar.month = this.leftCalendar.month.add(1, 'month');
      } else {
        this.rightCalendar.month = this.rightCalendar.month.add(1, 'month');
        if (this.linkedCalendars) {
          this.leftCalendar.month = this.leftCalendar.month.add(1, 'month');
        }
      }
      this.updateCalendars();
    };
    hoverDate(e, side, row, col) {
      const leftCalDate = this.calendarVariables.left.calendar[row][col];
      const rightCalDate = this.calendarVariables.right.calendar[row][col];
      if (this.pickingDate) {
        this.nowHoveredDate = side === SideEnum.left ? leftCalDate : rightCalDate;
        this.renderCalendar(SideEnum.left);
        this.renderCalendar(SideEnum.right);
      }
    }
    setCalendarPositionOnDateChange() {
      const disableProcessCalendarMonthChange = this.linkedCalendars || this.singleDatePicker || !this.startDate || !this.endDate;
      if (disableProcessCalendarMonthChange) return;
      const isCalendarsHadCorrectMonths = this.leftCalendar.month.month() === this.startDate.month() && this.rightCalendar.month.month() === this.endDate.month() && this.leftCalendar.month.year() === this.startDate.year() && this.rightCalendar.month.year() === this.endDate.year() || this.startDate.month() === this.endDate.month() && this.startDate.year() === this.endDate.year();
      if (isCalendarsHadCorrectMonths) return;
      this.leftCalendar.month = this.startDate;
      this.rightCalendar.month = this.endDate;
      this.updateCalendars();
    }
    clickDate(e, side, row, col) {
      if (this.rangeWithOngoingButton) this.isOngoingActive = false;
      if (e.target.tagName === 'TD') {
        if (!e.target.classList.contains('available')) {
          return;
        }
      } else if (e.target.tagName === 'SPAN') {
        if (!e.target.parentElement.classList.contains('available')) {
          return;
        }
      }
      if (this.rangesArray.length) {
        this.chosenRange = this.locale.customRangeLabel;
      }
      let date = side === SideEnum.left ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
      if ((this.endDate || date.isBefore(this.startDate, 'day') && this.customRangeDirection === false) && this.lockStartDate === false) {
        if (this.timePicker) {
          date = this.getDateWithTime(date, SideEnum.left);
        }
        this.endDate = null;
        this.setStartDate(date.clone());
      } else if (!this.endDate && date.isBefore(this.startDate) && this.customRangeDirection === false) {
        this.setEndDate(this.startDate.clone());
      } else {
        if (this.timePicker) {
          date = this.getDateWithTime(date, SideEnum.right);
        }
        if (date.isBefore(this.startDate, 'day') === true && this.customRangeDirection === true) {
          this.setEndDate(this.startDate);
          this.setStartDate(date.clone());
        } else {
          this.setEndDate(date.clone());
        }
        if (this.autoApply) {
          this.calculateChosenLabel();
        }
      }
      if (this.singleDatePicker) {
        this.setEndDate(this.startDate);
        this.updateElement();
        if (this.autoApply) {
          this.clickApply();
        }
      }
      this.updateView();
      if (this.autoApply && this.startDate && this.endDate) {
        this.clickApply();
      }
      this.setCalendarPositionOnDateChange();
      e.stopPropagation();
    }
    clickRange(e, label) {
      this.isOngoingActive = false;
      this.chosenRange = label;
      if (label === this.locale.customRangeLabel) {
        this.isShown = true;
        this.showCalInRanges = true;
      } else {
        const dates = this.ranges[label];
        this.startDate = dates[0].clone();
        this.endDate = dates[1].clone();
        if (this.showRangeLabelOnInput && label !== this.locale.customRangeLabel) {
          this.chosenLabel = label;
        } else {
          this.calculateChosenLabel();
        }
        this.showCalInRanges = !this.rangesArray.length || this.alwaysShowCalendars;
        if (!this.timePicker) {
          this.startDate = this.startDate.startOf('day');
          this.endDate = this.endDate.endOf('day');
        }
        if (!this.alwaysShowCalendars) {
          this.isShown = false;
        }
        this.rangeClicked.emit({
          label,
          dates
        });
        if (!this.keepCalendarOpeningWithRange || this.autoApply) {
          this.updateView();
          this.clickApply();
        } else {
          if (!this.alwaysShowCalendars) {
            return this.clickApply();
          }
          if (this.maxDate && this.maxDate.isSame(dates[0], 'month')) {
            this.rightCalendar.month = this.rightCalendar.month.month(dates[0].month());
            this.rightCalendar.month = this.rightCalendar.month.year(dates[0].year());
            this.leftCalendar.month = this.leftCalendar.month.month(dates[0].month() - 1);
            this.leftCalendar.month = this.leftCalendar.month.year(dates[1].year());
          } else {
            this.leftCalendar.month = this.leftCalendar.month.month(dates[0].month());
            this.leftCalendar.month = this.leftCalendar.month.year(dates[0].year());
            const nextMonth = !this.linkedCalendars ? dates[1].clone() : dates[0].clone().add(1, 'month');
            this.rightCalendar.month = this.rightCalendar.month.month(nextMonth.month());
            this.rightCalendar.month = this.rightCalendar.month.year(nextMonth.year());
          }
          this.updateCalendars();
          if (this.timePicker) {
            this.renderTimePicker(SideEnum.left);
            this.renderTimePicker(SideEnum.right);
          }
        }
      }
    }
    clickOngoing() {
      if (this.isOngoingActive) {
        this.isOngoingActive = false;
        this.chosenRange = this.locale.customRangeLabel;
      } else {
        this.chosenRange = '';
        this.isOngoingActive = true;
        this.startDate = null;
        this.endDate = null;
        this.choosedDate.emit({
          chosenLabel: this.locale.ongoingLabel,
          startDate: null,
          endDate: null
        });
        this.datesUpdated.emit({
          startDate: null,
          endDate: null
        });
        this.updateCalendars();
      }
      this.ongoingChange.emit(this.isOngoingActive);
    }
    show(e) {
      if (this.isShown) {
        return;
      }
      this.cachedVersion.start = this.startDate.clone();
      this.cachedVersion.end = this.endDate.clone();
      this.isShown = true;
      this.updateView();
      this.setCalendarPositionOnDateChange();
      this.calendarShow.emit();
    }
    hide(e) {
      if (!this.isShown) {
        return;
      }
      if (!this.endDate) {
        if (this.cachedVersion.start) {
          this.startDate = this.cachedVersion.start.clone();
        }
        if (this.cachedVersion.end) {
          this.endDate = this.cachedVersion.end.clone();
        }
      }
      this.updateElement();
      this.isShown = false;
      this.ref.detectChanges();
      this.calendarHide.emit();
    }
    updateLocale(locale) {
      for (const key in locale) {
        if (Object.prototype.hasOwnProperty.call(locale, key)) {
          this.locale[key] = locale[key];
          if (key === 'customRangeLabel') {
            this.renderRanges();
          }
        }
      }
    }
    clear() {
      this.startDate = dayjs().startOf('day');
      this.endDate = dayjs().endOf('day');
      this.choosedDate.emit({
        chosenLabel: '',
        startDate: null,
        endDate: null
      });
      this.datesUpdated.emit({
        startDate: null,
        endDate: null
      });
      this.clearClicked.emit();
      this.hide();
    }
    disableRange(range) {
      if (range === this.locale.customRangeLabel) {
        return false;
      }
      const rangeMarkers = this.ranges[range];
      const areBothBefore = rangeMarkers.every(date => {
        if (!this.minDate) {
          return false;
        }
        return date.isBefore(this.minDate);
      });
      const areBothAfter = rangeMarkers.every(date => {
        if (!this.maxDate) {
          return false;
        }
        return date.isAfter(this.maxDate);
      });
      return areBothBefore || areBothAfter;
    }
    getDateWithTime(date, side) {
      if (this.timepickerVariables[side]) {
        let hour = parseInt(String(this.timepickerVariables[side].selectedHour), 10);
        if (!this.timePicker24Hour) {
          const ampm = this.timepickerVariables[side].ampmModel;
          if (ampm === 'PM' && hour < 12) {
            hour += 12;
          }
          if (ampm === 'AM' && hour === 12) {
            hour = 0;
          }
        }
        const minute = parseInt(String(this.timepickerVariables[side].selectedMinute), 10);
        const second = this.timePickerSeconds ? parseInt(String(this.timepickerVariables[side].selectedSecond), 10) : 0;
        return date.clone().hour(hour).minute(minute).second(second);
      } else {
        return;
      }
    }
    buildLocale() {
      this.locale = {
        ...this.localeHolderService.config,
        ...this.locale
      };
      if (!this.locale.format) {
        if (this.timePicker) {
          this.locale.format = dayjs.localeData().longDateFormat('lll');
        } else {
          this.locale.format = dayjs.localeData().longDateFormat('L');
        }
      }
    }
    buildCells(calendar, side) {
      for (let row = 0; row < 6; row++) {
        this.calendarVariables[side].classes[row] = {
          classList: ''
        };
        const rowClasses = [];
        if (this.emptyWeekRowClass && Array.from(Array(7).keys()).some(i => calendar[row][i].month() !== this.calendarVariables[side].month)) {
          rowClasses.push(this.emptyWeekRowClass);
        }
        for (let col = 0; col < 7; col++) {
          const classes = [];
          if (this.emptyWeekColumnClass) {
            if (calendar[row][col].month() !== this.calendarVariables[side].month) {
              classes.push(this.emptyWeekColumnClass);
            }
          }
          if (calendar[row][col].isSame(dayjs(), 'day')) {
            classes.push('today');
          }
          if (calendar[row][col].isoWeekday() > 5) {
            classes.push('weekend');
          }
          if (calendar[row][col].month() !== calendar[1][1].month()) {
            classes.push('off');
            if (this.lastDayOfPreviousMonthClass && (calendar[row][col].month() < calendar[1][1].month() || calendar[1][1].month() === 0) && calendar[row][col].date() === this.calendarVariables[side].daysInLastMonth) {
              classes.push(this.lastDayOfPreviousMonthClass);
            }
            if (this.firstDayOfNextMonthClass && (calendar[row][col].month() > calendar[1][1].month() || calendar[row][col].month() === 0) && calendar[row][col].date() === 1) {
              classes.push(this.firstDayOfNextMonthClass);
            }
          }
          if (this.firstMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.firstDay.date()) {
            classes.push(this.firstMonthDayClass);
          }
          if (this.lastMonthDayClass && calendar[row][col].month() === calendar[1][1].month() && calendar[row][col].date() === calendar.lastDay.date()) {
            classes.push(this.lastMonthDayClass);
          }
          if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) {
            classes.push('off', 'disabled');
          }
          if (this.calendarVariables[side].maxDate && calendar[row][col].isAfter(this.calendarVariables[side].maxDate, 'day')) {
            classes.push('off', 'disabled');
          }
          if (this.isInvalidDate(calendar[row][col])) {
            classes.push('off', 'disabled', 'invalid');
          }
          if (this.startDate && calendar[row][col].format('YYYY-MM-DD') === this.startDate.format('YYYY-MM-DD')) {
            classes.push('active', 'start-date');
          }
          if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD')) {
            classes.push('active', 'end-date');
          }
          if ((this.nowHoveredDate != null && this.pickingDate || this.endDate != null) && calendar[row][col] > this.startDate && (calendar[row][col] < this.endDate || calendar[row][col] < this.nowHoveredDate && this.pickingDate) && !classes.find(el => el === 'off')) {
            classes.push('in-range');
          }
          const isCustom = this.isCustomDate(calendar[row][col]);
          if (isCustom !== false) {
            if (typeof isCustom === 'string') {
              classes.push(isCustom);
            } else {
              Array.prototype.push.apply(classes, isCustom);
            }
          }
          let cname = '';
          let disabled = false;
          for (const className of classes) {
            cname += className + ' ';
            if (className === 'disabled') {
              disabled = true;
            }
          }
          if (!disabled) {
            cname += 'available';
          }
          this.calendarVariables[side].classes[row][col] = cname.replace(/^\s+|\s+$/g, '');
        }
        this.calendarVariables[side].classes[row].classList = rowClasses.join(' ');
      }
    }
    static ɵfac = function DaterangepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DaterangepickerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(LocaleService), i0.ɵɵdirectiveInject(ThemeService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DaterangepickerComponent,
      selectors: [["ngx-daterangepicker-material"]],
      viewQuery: function DaterangepickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pickerContainer = _t.first);
        }
      },
      hostBindings: function DaterangepickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DaterangepickerComponent_click_HostBindingHandler($event) {
            return ctx.handleInternalClick($event);
          });
        }
      },
      inputs: {
        startDate: "startDate",
        endDate: "endDate",
        dateLimit: [2, "dateLimit", "dateLimit", numberAttribute],
        autoApply: [2, "autoApply", "autoApply", booleanAttribute],
        singleDatePicker: [2, "singleDatePicker", "singleDatePicker", booleanAttribute],
        showDropdowns: [2, "showDropdowns", "showDropdowns", booleanAttribute],
        showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute],
        showISOWeekNumbers: [2, "showISOWeekNumbers", "showISOWeekNumbers", booleanAttribute],
        linkedCalendars: [2, "linkedCalendars", "linkedCalendars", booleanAttribute],
        autoUpdateInput: [2, "autoUpdateInput", "autoUpdateInput", booleanAttribute],
        alwaysShowCalendars: [2, "alwaysShowCalendars", "alwaysShowCalendars", booleanAttribute],
        maxSpan: [2, "maxSpan", "maxSpan", booleanAttribute],
        lockStartDate: [2, "lockStartDate", "lockStartDate", booleanAttribute],
        timePicker: [2, "timePicker", "timePicker", booleanAttribute],
        timePicker24Hour: [2, "timePicker24Hour", "timePicker24Hour", booleanAttribute],
        timePickerIncrement: [2, "timePickerIncrement", "timePickerIncrement", booleanAttribute],
        timePickerSeconds: [2, "timePickerSeconds", "timePickerSeconds", booleanAttribute],
        showClearButton: [2, "showClearButton", "showClearButton", booleanAttribute],
        firstMonthDayClass: "firstMonthDayClass",
        lastMonthDayClass: "lastMonthDayClass",
        emptyWeekRowClass: "emptyWeekRowClass",
        emptyWeekColumnClass: "emptyWeekColumnClass",
        firstDayOfNextMonthClass: "firstDayOfNextMonthClass",
        lastDayOfPreviousMonthClass: "lastDayOfPreviousMonthClass",
        showCustomRangeLabel: [2, "showCustomRangeLabel", "showCustomRangeLabel", booleanAttribute],
        showCancel: [2, "showCancel", "showCancel", booleanAttribute],
        keepCalendarOpeningWithRange: [2, "keepCalendarOpeningWithRange", "keepCalendarOpeningWithRange", booleanAttribute],
        showRangeLabelOnInput: [2, "showRangeLabelOnInput", "showRangeLabelOnInput", booleanAttribute],
        customRangeDirection: [2, "customRangeDirection", "customRangeDirection", booleanAttribute],
        rangeWithOngoingButton: [2, "rangeWithOngoingButton", "rangeWithOngoingButton", booleanAttribute],
        drops: "drops",
        opens: "opens",
        closeOnAutoApply: [2, "closeOnAutoApply", "closeOnAutoApply", booleanAttribute],
        minDate: "minDate",
        locale: "locale",
        ranges: "ranges",
        ongoing: "ongoing",
        maxDate: "maxDate",
        isInvalidDate: "isInvalidDate",
        isCustomDate: "isCustomDate",
        isTooltipDate: "isTooltipDate"
      },
      outputs: {
        choosedDate: "choosedDate",
        rangeClicked: "rangeClicked",
        datesUpdated: "datesUpdated",
        startDateChanged: "startDateChanged",
        endDateChanged: "endDateChanged",
        cancelClicked: "cancelClicked",
        clearClicked: "clearClicked",
        ongoingChange: "ongoingChange",
        calendarShow: "calendarShow",
        calendarHide: "calendarHide"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DaterangepickerComponent),
        multi: true
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
      decls: 8,
      vars: 16,
      consts: [["pickerContainer", ""], [1, "md-drppicker", 3, "ngClass"], [1, "calendar-wrapper"], ["class", "ranges", 4, "ngIf"], ["class", "calendar", 3, "ngClass", 4, "ngIf"], ["class", "calendar-separator", 4, "ngIf"], ["class", "calendar right", 4, "ngIf"], ["class", "buttons", 4, "ngIf"], [1, "ranges"], [4, "ngFor", "ngForOf"], ["class", "ongoing", "type", "button", 3, "class", "click", 4, "ngIf"], ["type", "button", 3, "click", "disabled", "ngClass"], ["type", "button", 1, "ongoing", 3, "click"], [1, "calendar", 3, "ngClass"], [1, "calendar-table"], ["class", "table-condensed", 4, "ngIf"], ["class", "calendar-time", 3, "ngClass", 4, "ngIf"], [1, "table-condensed"], [4, "ngIf"], ["colspan", "5", 1, "month", "drp-animate"], [1, "week-days"], ["class", "week", 4, "ngIf"], [1, "drp-animate"], [3, "class", 4, "ngFor", "ngForOf"], [1, "prev", "available", 3, "click"], [1, "dropdowns-wrapper"], [1, "dropdowns"], [1, "monthselect", 3, "change"], [3, "disabled", "value", "selected", 4, "ngFor", "ngForOf"], [1, "yearselect", 3, "change"], [3, "selected", 4, "ngFor", "ngForOf"], [3, "disabled", "value", "selected"], [3, "selected"], [1, "next", "available", 3, "click"], [1, "week"], [3, "class", "click", "mouseenter", 4, "ngFor", "ngForOf"], [3, "click", "mouseenter"], [1, "calendar-time", 3, "ngClass"], [1, "hourselect", "select-item", 3, "ngModelChange", "disabled", "ngModel"], [3, "value", "disabled", 4, "ngFor", "ngForOf"], [1, "calendar-time-separator"], [1, "select-item", "minuteselect", 3, "ngModelChange", "disabled", "ngModel"], ["class", "dropdowns", 4, "ngIf"], [3, "value", "disabled"], [1, "select-item", "secondselect", 3, "ngModelChange", "disabled", "ngModel"], [1, "select-item", "ampmselect", 3, "ngModelChange", "ngModel"], ["value", "AM", 3, "disabled"], ["value", "PM", 3, "disabled"], [1, "calendar-separator"], [1, "calendar", "right"], ["class", "calendar-time", 4, "ngIf"], ["colspan", "5", 1, "month"], [1, "calendar-time"], [1, "select-item", "hourselect", 3, "ngModelChange", "disabled", "ngModel"], [1, "buttons"], ["class", "btn btn-default clear", "type", "button", 3, "title", "click", 4, "ngIf"], ["class", "btn btn-default", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", 3, "click", "disabled"], ["type", "button", 1, "btn", "btn-default", "clear", 3, "click", "title"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24"], ["d", "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"], ["type", "button", 1, "btn", "btn-default", 3, "click"]],
      template: function DaterangepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2);
          i0.ɵɵtemplate(3, DaterangepickerComponent_div_3_Template, 4, 2, "div", 3)(4, DaterangepickerComponent_div_4_Template, 4, 6, "div", 4)(5, DaterangepickerComponent_div_5_Template, 1, 0, "div", 5)(6, DaterangepickerComponent_div_6_Template, 4, 2, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, DaterangepickerComponent_div_7_Template, 5, 4, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap("drops-" + ctx.drops + "-" + ctx.opens);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(8, _c1, ctx.locale.direction === "ltr", ctx.locale.direction === "rtl", ctx.isShown || ctx.inline, !ctx.isShown && !ctx.inline, ctx.inline, !ctx.singleDatePicker && ctx.showCalInRanges, ctx.rangesArray.length));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.rangesArray.length);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showCalInRanges);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.singleDatePicker);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showCalInRanges && !ctx.singleDatePicker);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.autoApply && (!ctx.rangesArray.length || ctx.showCalInRanges && !ctx.singleDatePicker));
        }
      },
      dependencies: [NgClass, NgIf, NgForOf, FormsModule, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.NgModel],
      styles: [".md-drppicker{position:absolute;margin-top:-10px;font-family:inherit;color:var(--datepicker-color);background-color:var(--datepicker-bgColor);border-radius:4px;padding:var(--datepicker-calendarMargin);overflow:hidden;z-index:1000;box-shadow:0 1px 40px #0000001a}.md-drppicker *{box-sizing:border-box}.md-drppicker select{cursor:pointer}.md-drppicker .calendar-wrapper{display:flex;max-width:min-content}.md-drppicker .dropdowns-wrapper{display:flex;align-items:center;justify-content:center;gap:4px}.md-drppicker.double{width:var(--datepicker-widthDouble)}.md-drppicker.double .right .calendar-table{padding-left:12px;border-left:1px solid var(--datepicker-separatorColor)}.md-drppicker.double .left .calendar-table{padding-right:12px}.md-drppicker.inline{position:relative;display:inline-flex}.md-drppicker:before,.md-drppicker:after{position:absolute;display:inline-block;border-bottom-color:#0003;content:\"\"}.md-drppicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.openscenter:after{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.md-drppicker.shown{transform:scale(1);transition:all .1s ease-in-out;transform-origin:0 0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.md-drppicker.shown.drops-up-left{transform-origin:100% 100%}.md-drppicker.shown.drops-up-right{transform-origin:0 100%}.md-drppicker.shown.drops-down-left{transform-origin:100% 0}.md-drppicker.shown.drops-down-right{transform-origin:0 0}.md-drppicker.shown.drops-down-center{transform-origin:calc(NaN * 1%)}.md-drppicker.shown.drops-up-center{transform-origin:50%}.md-drppicker.shown .calendar{display:block}.md-drppicker.hidden{transition:all .1s ease;transform:scale(0);transform-origin:0 0;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.md-drppicker.hidden.drops-up-left{transform-origin:100% 100%}.md-drppicker.hidden.drops-up-right{transform-origin:0 100%}.md-drppicker.hidden.drops-down-left{transform-origin:100% 0}.md-drppicker.hidden.drops-down-right{transform-origin:0 0}.md-drppicker.hidden.drops-down-center{transform-origin:50% 0}.md-drppicker.hidden.drops-up-center{transform-origin:50% 100%}.md-drppicker.hidden .calendar{display:none}.md-drppicker .calendar.single .calendar-table{border:none}.md-drppicker .calendar th,.md-drppicker .calendar td{padding:0;white-space:nowrap;text-align:center;min-width:32px}.md-drppicker .calendar th span,.md-drppicker .calendar td span{pointer-events:none}.md-drppicker .calendar-table{border:var(--datepicker-calendarBorderSize) solid var(--datepicker-calendarBorderColor);border-radius:var(--datepicker-calendarBorderRadius);background-color:var(--datepicker-calendarBgColor)}.md-drppicker table{width:100%;margin:0;border-spacing:0 4px;border-collapse:separate}.md-drppicker tr{border:none}.md-drppicker th{color:#988c8c}.week-days .md-drppicker th{color:var(--datepicker-cellWeekdayNameColor);font-size:var(--datepicker-cellWeekdayNameFontSize);font-weight:var(--datepicker-cellWeekdayNameFontWeight)}.md-drppicker td{font-size:var(--datepicker-cellFontSize)}.md-drppicker td,.md-drppicker th{text-align:center;width:var(--datepicker-cellWidth);height:var(--datepicker-cellHeight);border-radius:var(--datepicker-cellBorderRadius);border:var(--datepicker-cellBorderSize) solid var(--datepicker-cellBorderRadius);white-space:nowrap;cursor:pointer}.md-drppicker td.available.prev,.md-drppicker td.available.next,.md-drppicker th.available.prev,.md-drppicker th.available.next{display:flex;justify-content:center;align-items:center}.md-drppicker td.available.prev:before,.md-drppicker td.available.next:before,.md-drppicker th.available.prev:before,.md-drppicker th.available.next:before{content:\"\";display:block;width:0;height:0;border-top:3px solid transparent;border-bottom:3px solid transparent}.md-drppicker td.available.prev:hover,.md-drppicker td.available.next:hover,.md-drppicker th.available.prev:hover,.md-drppicker th.available.next:hover{background-color:var(--datepicker-cellHoverBgColor)}.md-drppicker td.available.next:before,.md-drppicker th.available.next:before{border-left:4px solid var(--datepicker-cellColor)}.md-drppicker td.available.prev:before,.md-drppicker th.available.prev:before{border-right:4px solid var(--datepicker-cellColor)}.md-drppicker td.available:not(.prev):not(.next):not(.active):hover,.md-drppicker th.available:not(.prev):not(.next):not(.active):hover{background-color:var(--datepicker-cellHoverBgColor);border-color:var(--datepicker-cellHoverBorderColor);color:var(--datepicker-cellHoverColor);border-radius:var(--datepicker-cellBorderRadius);font-weight:var(--datepicker-cellHoverFontWeight);transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.week,.md-drppicker th.week{font-size:80%;color:#ccc}.md-drppicker td{margin:.25em 0;transition:background-color .2s ease;border-radius:2em;transform:scale(1);transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}.md-drppicker td.off,.md-drppicker td.off.in-range,.md-drppicker td.off.start-date,.md-drppicker td.off.end-date{background-color:var(--datepicker-unselectedBgColor);border-color:var(--datepicker-unselectedBorderColor);color:var(--datepicker-unselectedColor);font-weight:var(--datepicker-inRangeFontWeight)}.md-drppicker td.in-range{background-color:var(--datepicker-inRangeBgColor);border-color:var(--datepicker-inRangeBorderColor);color:var(--datepicker-inRangeColor);font-weight:var(--datepicker-inRangeFontWeight);border-radius:0}.md-drppicker td.start-date{border-radius:var(--datepicker-cellBorderRadius) 0 0 var(--datepicker-cellBorderRadius);font-weight:var(--datepicker-inRangeFontWeight)}.md-drppicker td.end-date{border-radius:0 var(--datepicker-cellBorderRadius) var(--datepicker-cellBorderRadius) 0;font-weight:var(--datepicker-inRangeFontWeight)}.md-drppicker td.start-date.end-date{border-radius:var(--datepicker-cellBorderRadius)}.md-drppicker td.active,.md-drppicker td.active:hover{background-color:var(--datepicker-activeBgColor);border-color:var(--datepicker-activeBorderColor);color:var(--datepicker-activeColor)}.md-drppicker th.month{width:auto}.md-drppicker td.disabled,.md-drppicker option.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.md-drppicker .dropdowns{position:relative}.md-drppicker .dropdowns select{position:relative;display:block;width:min-content;height:var(--datepicker-inputHeight);padding:var(--datepicker-selectPadding);padding-right:20px;appearance:none;font-size:var(--datepicker-selectFontSize);color:var(--datepicker-selectColor);border:var(--datepicker-selectBorder);border-radius:var(--datepicker-selectRadius);outline:none}.md-drppicker .dropdowns select:hover{border-color:var(--datepicker-hoverCustomRangeBorderColor)}.md-drppicker .dropdowns select:focus{outline:1px solid var(--datepicker-hoverCustomRangeBorderColor)}.md-drppicker .dropdowns:after{content:\"\";position:absolute;top:50%;right:8px;display:block;width:0;height:0;margin-top:-2px;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid var(--datepicker-cellColor);pointer-events:none}.md-drppicker .left .calendar-time{justify-content:flex-end;padding-right:23px}.md-drppicker .left .calendar-time:before{content:\"-\";position:absolute;top:0;right:-3px;display:flex;justify-content:center;align-items:center;width:6px;height:var(--datepicker-inputHeight);font-size:var(--datepicker-selectFontSize);color:var(--datepicker-cellColor)}.md-drppicker .right .calendar-time{padding-left:23px}.md-drppicker .calendar-time{position:relative;display:flex;align-items:center;gap:4px;margin-top:24px}.md-drppicker .calendar-time.center{justify-content:center}.md-drppicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.md-drppicker .calendar-time-separator{color:var(--datepicker-cellColor);font-size:var(--datepicker-selectFontSize)}.md-drppicker .label-input{border:var(--datepicker-controlBorderSize) solid var(--datepicker-controlBorderColor);border-radius:var(--datepicker-controlBorderRadius);color:var(--datepicker-controlColor);height:var(--datepicker-controlLineHeight);line-height:var(--datepicker-controlHeight);display:block;vertical-align:middle;margin:0 auto 5px;padding:0 0 0 28px;width:100%}.md-drppicker .label-input.active{border:var(--datepicker-controlActiveBorderSize) solid var(--datepicker-controlActiveBorderColor);border-radius:var(--datepicker-controlActiveBorderRadius)}.md-drppicker .md-drppicker_input{position:relative;padding:0 30px 0 0}.md-drppicker .md-drppicker_input i,.md-drppicker .md-drppicker_input svg{position:absolute;left:8px;top:8px}.md-drppicker.rtl .label-input{padding-right:28px;padding-left:6px}.md-drppicker.rtl .md-drppicker_input i,.md-drppicker.rtl .md-drppicker_input svg{left:auto;right:8px}.md-drppicker .show-ranges .drp-calendar.left{border-left:1px solid #ddd}.md-drppicker .ranges{display:flex;flex-direction:column;margin-right:24px}.md-drppicker .ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.md-drppicker .ranges ul li{font-size:var(--datepicker-cellFontSize)}.md-drppicker .ranges ul li button{width:100%;height:var(--datepicker-cellHeight);padding-left:8px;background:none;border:none;border-left:1px solid var(--datepicker-separatorColor);cursor:pointer;text-align:left;white-space:nowrap;outline:none;color:var(--datepicker-cellColor)}.md-drppicker .ranges ul li button:hover{color:var(--datepicker-selectColor);border-left-color:var(--datepicker-hoverCustomRangeBorderColor)}.md-drppicker .ranges ul li button.active{color:var(--datepicker-selectColor);border-left-color:var(--datepicker-activeBgColor);text-shadow:0 0 .2px var(--datepicker-selectColor)}.md-drppicker .ranges ul li button[disabled]{opacity:.3}.md-drppicker .ongoing{height:var(--datepicker-cellHeight);margin-top:auto;padding:0 24px;text-align:center;border:1px solid var(--datepicker-separatorColor);color:var(--datepicker-inRangeColor);background-color:transparent;font-weight:var(--datepicker-inRangeFontWeight);border-radius:var(--datepicker-calendarBorderRadius);cursor:pointer}.md-drppicker .ongoing.active{border-color:var(--datepicker-activeBgColor);color:var(--datepicker-activeBgColor)}.md-drppicker [hidden]{display:none}.md-drppicker .buttons{display:flex;justify-content:flex-end;align-items:center;gap:8px;margin-top:12px}.md-drppicker .btn{position:relative;display:inline-flex;justify-content:center;align-items:center;height:auto;padding:0 6px;overflow:hidden;border-width:0;outline:none;cursor:pointer;border-radius:2px;box-shadow:0 1px 4px #0009;background-color:#3f51b5;color:#ecf0f1;transition:background-color .4s;text-transform:uppercase;line-height:36px;border:none}.md-drppicker .btn:hover,.md-drppicker .btn:focus{background-color:#3f51b5}.md-drppicker .btn>*{position:relative}.md-drppicker .btn span{display:block;padding:12px 24px}.md-drppicker .btn:before{content:\"\";position:absolute;top:50%;left:50%;display:block;width:0;padding-top:0;border-radius:100%;background-color:#ecf0f14d;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.md-drppicker .btn:active:before{width:120%;padding-top:120%;transition:width .2s ease-out,padding-top .2s ease-out}.md-drppicker .btn:disabled{opacity:.5}.md-drppicker .btn.btn-default{color:#000;background-color:#dcdcdc}.md-drppicker .clear{box-shadow:none;background-color:#fff!important}.md-drppicker .clear svg{color:#eb3232;fill:currentColor}@media (min-width: 564px){.md-drppicker{width:auto}.md-drppicker.single .calendar.left{clear:none}.md-drppicker.ltr{direction:ltr;text-align:left}.md-drppicker.ltr .calendar.left{clear:left}.md-drppicker.ltr .calendar.right{margin-left:0}.md-drppicker.ltr .left .md-drppicker_input,.md-drppicker.ltr .right .md-drppicker_input{padding-right:35px}.md-drppicker.rtl{direction:rtl;text-align:right}.md-drppicker.rtl .calendar.left{clear:right;margin-left:0}.md-drppicker.rtl .calendar.right{margin-right:0}.md-drppicker.rtl .left .md-drppicker_input,.md-drppicker.rtl .calendar.left .calendar-table{padding-left:12px}.md-drppicker.rtl .ranges,.md-drppicker.rtl .calendar{text-align:right;float:right}.drp-animate{transform:translate(0);transition:transform .2s ease,opacity .2s ease}.drp-animate.drp-picker-site-this{transition-timing-function:linear}.drp-animate.drp-animate-right{transform:translate(10%);opacity:0}.drp-animate.drp-animate-left{transform:translate(-10%);opacity:0}}@media (min-width: 730px){.md-drppicker .ranges{width:auto}.md-drppicker.ltr .ranges{float:left}.md-drppicker.rtl .ranges{float:right}.md-drppicker .calendar.left{clear:none!important}}\n"],
      encapsulation: 2
    });
  }
  return DaterangepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DaterangepickerDirective = /*#__PURE__*/(() => {
  class DaterangepickerDirective {
    viewContainerRef;
    ref;
    el;
    renderer;
    differs;
    localeHolderService;
    elementRef;
    onChange = new EventEmitter();
    rangeClicked = new EventEmitter();
    datesUpdated = new EventEmitter();
    startDateChanged = new EventEmitter();
    endDateChanged = new EventEmitter();
    clearClicked = new EventEmitter();
    calendarShow = new EventEmitter();
    calendarHide = new EventEmitter();
    minDate;
    maxDate;
    autoApply;
    alwaysShowCalendars;
    showCustomRangeLabel;
    linkedCalendars;
    dateLimit = null;
    singleDatePicker;
    showWeekNumbers;
    showISOWeekNumbers;
    showDropdowns;
    isInvalidDate;
    isCustomDate;
    isTooltipDate;
    showClearButton;
    customRangeDirection;
    ranges;
    opens;
    drops;
    firstMonthDayClass;
    lastMonthDayClass;
    emptyWeekRowClass;
    emptyWeekColumnClass;
    firstDayOfNextMonthClass;
    lastDayOfPreviousMonthClass;
    keepCalendarOpeningWithRange;
    showRangeLabelOnInput;
    showCancel = false;
    lockStartDate = false;
    timePicker = false;
    timePicker24Hour = false;
    timePickerIncrement = 1;
    timePickerSeconds = false;
    closeOnAutoApply = true;
    endKeyHolder;
    rangeWithOngoingButton = false;
    picker;
    startKeyHolder;
    notForChangesProperty = ['locale', 'endKey', 'startKey'];
    onChangeFn = Function.prototype;
    onTouched = Function.prototype;
    validatorChange = Function.prototype;
    disabledHolder;
    valueHolder;
    localeDiffer;
    localeHolder = {};
    constructor(viewContainerRef, ref, el, renderer, differs, localeHolderService, elementRef) {
      this.viewContainerRef = viewContainerRef;
      this.ref = ref;
      this.el = el;
      this.renderer = renderer;
      this.differs = differs;
      this.localeHolderService = localeHolderService;
      this.elementRef = elementRef;
      this.endKey = 'endDate';
      this.startKey = 'startDate';
      this.drops = 'down';
      this.opens = 'auto';
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(DaterangepickerComponent);
      this.picker = componentRef.instance;
      this.picker.inline = false;
    }
    get disabled() {
      return this.disabledHolder;
    }
    set startKey(value) {
      if (value !== null) {
        this.startKeyHolder = value;
      } else {
        this.startKeyHolder = 'startDate';
      }
    }
    get locale() {
      return this.localeHolder;
    }
    set locale(value) {
      this.localeHolder = {
        ...this.localeHolderService.config,
        ...value
      };
    }
    set endKey(value) {
      if (value !== null) {
        this.endKeyHolder = value;
      } else {
        this.endKeyHolder = 'endDate';
      }
    }
    get value() {
      return this.valueHolder || null;
    }
    set value(val) {
      this.valueHolder = val;
      this.onChangeFn(val);
      this.ref.markForCheck();
    }
    outsideClick(event) {
      if (!event.target) {
        return;
      }
      if (event.target.classList.contains('ngx-daterangepicker-action')) {
        return;
      }
      if (!this.elementRef.nativeElement.contains(event.target)) {
        this.hide();
      }
    }
    hide(e) {
      this.picker.hide(e);
    }
    onBlur() {
      this.onTouched();
    }
    inputChanged(e) {
      if (e.target.tagName.toLowerCase() !== 'input') {
        return;
      }
      if (!e.target.value.length) {
        return;
      }
      const dateString = e.target.value.split(this.picker.locale.separator);
      let start = null;
      let end = null;
      if (dateString.length === 2) {
        start = dayjs(dateString[0], this.picker.locale.format);
        end = dayjs(dateString[1], this.picker.locale.format);
      }
      if (this.singleDatePicker || start === null || end === null) {
        start = dayjs(e.target.value, this.picker.locale.format);
        end = start;
      }
      if (!start.isValid() || !end.isValid()) {
        return;
      }
      this.picker.setStartDate(start);
      this.picker.setEndDate(end);
      this.picker.updateView();
    }
    open(event) {
      if (this.disabled) {
        return;
      }
      this.picker.show(event);
      setTimeout(() => {
        this.setPosition();
      });
    }
    ngOnInit() {
      this.picker.startDateChanged.asObservable().subscribe(itemChanged => {
        this.startDateChanged.emit(itemChanged);
      });
      this.picker.endDateChanged.asObservable().subscribe(itemChanged => {
        this.endDateChanged.emit(itemChanged);
      });
      this.picker.rangeClicked.asObservable().subscribe(range => {
        this.rangeClicked.emit(range);
      });
      this.picker.datesUpdated.asObservable().subscribe(range => {
        this.datesUpdated.emit(range);
      });
      this.picker.clearClicked.asObservable().subscribe(() => {
        this.clearClicked.emit();
      });
      this.picker.calendarShow.asObservable().subscribe(() => {
        this.calendarShow.emit();
      });
      this.picker.calendarHide.asObservable().subscribe(() => {
        this.calendarHide.emit();
      });
      this.picker.choosedDate.asObservable().subscribe(change => {
        if (change) {
          const value = {
            [this.startKeyHolder]: change.startDate,
            [this.endKeyHolder]: change.endDate
          };
          this.value = value;
          this.onChange.emit(value);
          if (typeof change.chosenLabel === 'string') {
            this.el.nativeElement.value = change.chosenLabel;
          }
        }
      });
      this.picker.firstMonthDayClass = this.firstMonthDayClass;
      this.picker.lastMonthDayClass = this.lastMonthDayClass;
      this.picker.emptyWeekRowClass = this.emptyWeekRowClass;
      this.picker.emptyWeekColumnClass = this.emptyWeekColumnClass;
      this.picker.firstDayOfNextMonthClass = this.firstDayOfNextMonthClass;
      this.picker.lastDayOfPreviousMonthClass = this.lastDayOfPreviousMonthClass;
      this.picker.drops = this.drops;
      this.picker.opens = this.opens;
      this.localeDiffer = this.differs.find(this.locale).create();
      this.picker.closeOnAutoApply = this.closeOnAutoApply;
      this.picker.rangeWithOngoingButton = this.rangeWithOngoingButton;
    }
    ngOnChanges(changes) {
      for (const change in changes) {
        if (Object.prototype.hasOwnProperty.call(changes, change)) {
          if (this.notForChangesProperty.indexOf(change) === -1) {
            this.picker[change] = changes[change].currentValue;
          }
        }
      }
    }
    ngDoCheck() {
      if (this.localeDiffer) {
        const changes = this.localeDiffer.diff(this.locale);
        if (changes) {
          this.picker.updateLocale(this.locale);
        }
      }
    }
    toggle(e) {
      if (this.picker.isShown) {
        this.hide(e);
      } else {
        this.open(e);
      }
    }
    clear() {
      this.picker.clear();
    }
    writeValue(value) {
      this.setValue(value);
    }
    registerOnChange(fn) {
      this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(state) {
      this.disabledHolder = state;
    }
    setPosition() {
      let style;
      let containerTop;
      const container = this.picker.pickerContainer.nativeElement;
      const element = this.el.nativeElement;
      if (this.drops && this.drops === 'up') {
        containerTop = element.offsetTop - container.clientHeight + 'px';
      } else {
        containerTop = 'auto';
      }
      if (this.opens === 'left') {
        style = {
          top: containerTop,
          left: element.offsetLeft - container.clientWidth + element.clientWidth + 'px',
          right: 'auto'
        };
      } else if (this.opens === 'center') {
        style = {
          top: containerTop,
          left: element.offsetLeft + element.clientWidth / 2 - container.clientWidth / 2 + 'px',
          right: 'auto'
        };
      } else if (this.opens === 'right') {
        style = {
          top: containerTop,
          left: element.offsetLeft + 'px',
          right: 'auto'
        };
      } else {
        const position = element.offsetLeft + element.clientWidth / 2 - container.clientWidth / 2;
        if (position < 0) {
          style = {
            top: containerTop,
            left: element.offsetLeft + 'px',
            right: 'auto'
          };
        } else {
          style = {
            top: containerTop,
            left: position + 'px',
            right: 'auto'
          };
        }
      }
      if (style) {
        this.renderer.setStyle(container, 'top', style.top);
        this.renderer.setStyle(container, 'left', style.left);
        this.renderer.setStyle(container, 'right', style.right);
      }
    }
    setValue(val) {
      if (val) {
        this.value = val;
        if (val[this.startKeyHolder]) {
          this.picker.setStartDate(val[this.startKeyHolder]);
        }
        if (val[this.endKeyHolder]) {
          this.picker.setEndDate(val[this.endKeyHolder]);
        }
        this.picker.calculateChosenLabel();
        if (this.picker.chosenLabel) {
          this.el.nativeElement.value = this.picker.chosenLabel;
        }
      } else {
        this.picker.clear();
      }
    }
    static ɵfac = function DaterangepickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DaterangepickerDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.KeyValueDiffers), i0.ɵɵdirectiveInject(LocaleService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DaterangepickerDirective,
      selectors: [["input", "ngxDaterangepickerMd", ""]],
      hostVars: 1,
      hostBindings: function DaterangepickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DaterangepickerDirective_click_HostBindingHandler($event) {
            return ctx.outsideClick($event);
          }, false, i0.ɵɵresolveDocument)("keyup.esc", function DaterangepickerDirective_keyup_esc_HostBindingHandler($event) {
            return ctx.hide($event);
          })("blur", function DaterangepickerDirective_blur_HostBindingHandler() {
            return ctx.onBlur();
          })("keyup", function DaterangepickerDirective_keyup_HostBindingHandler($event) {
            return ctx.inputChanged($event);
          })("click", function DaterangepickerDirective_click_HostBindingHandler($event) {
            return ctx.open($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("disabled", ctx.disabled);
        }
      },
      inputs: {
        minDate: "minDate",
        maxDate: "maxDate",
        autoApply: [2, "autoApply", "autoApply", booleanAttribute],
        alwaysShowCalendars: [2, "alwaysShowCalendars", "alwaysShowCalendars", booleanAttribute],
        showCustomRangeLabel: [2, "showCustomRangeLabel", "showCustomRangeLabel", booleanAttribute],
        linkedCalendars: [2, "linkedCalendars", "linkedCalendars", booleanAttribute],
        dateLimit: [2, "dateLimit", "dateLimit", numberAttribute],
        singleDatePicker: [2, "singleDatePicker", "singleDatePicker", booleanAttribute],
        showWeekNumbers: [2, "showWeekNumbers", "showWeekNumbers", booleanAttribute],
        showISOWeekNumbers: [2, "showISOWeekNumbers", "showISOWeekNumbers", booleanAttribute],
        showDropdowns: [2, "showDropdowns", "showDropdowns", booleanAttribute],
        isInvalidDate: "isInvalidDate",
        isCustomDate: "isCustomDate",
        isTooltipDate: "isTooltipDate",
        showClearButton: [2, "showClearButton", "showClearButton", booleanAttribute],
        customRangeDirection: [2, "customRangeDirection", "customRangeDirection", booleanAttribute],
        ranges: "ranges",
        opens: "opens",
        drops: "drops",
        firstMonthDayClass: "firstMonthDayClass",
        lastMonthDayClass: "lastMonthDayClass",
        emptyWeekRowClass: "emptyWeekRowClass",
        emptyWeekColumnClass: "emptyWeekColumnClass",
        firstDayOfNextMonthClass: "firstDayOfNextMonthClass",
        lastDayOfPreviousMonthClass: "lastDayOfPreviousMonthClass",
        keepCalendarOpeningWithRange: [2, "keepCalendarOpeningWithRange", "keepCalendarOpeningWithRange", booleanAttribute],
        showRangeLabelOnInput: [2, "showRangeLabelOnInput", "showRangeLabelOnInput", booleanAttribute],
        showCancel: [2, "showCancel", "showCancel", booleanAttribute],
        lockStartDate: [2, "lockStartDate", "lockStartDate", booleanAttribute],
        timePicker: [2, "timePicker", "timePicker", booleanAttribute],
        timePicker24Hour: [2, "timePicker24Hour", "timePicker24Hour", booleanAttribute],
        timePickerIncrement: [2, "timePickerIncrement", "timePickerIncrement", numberAttribute],
        timePickerSeconds: [2, "timePickerSeconds", "timePickerSeconds", booleanAttribute],
        closeOnAutoApply: [2, "closeOnAutoApply", "closeOnAutoApply", booleanAttribute],
        endKeyHolder: "endKeyHolder",
        rangeWithOngoingButton: [2, "rangeWithOngoingButton", "rangeWithOngoingButton", booleanAttribute],
        startKey: "startKey",
        locale: "locale",
        endKey: "endKey"
      },
      outputs: {
        onChange: "change",
        rangeClicked: "rangeClicked",
        datesUpdated: "datesUpdated",
        startDateChanged: "startDateChanged",
        endDateChanged: "endDateChanged",
        clearClicked: "clearClicked",
        calendarShow: "calendarShow",
        calendarHide: "calendarHide"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DaterangepickerDirective),
        multi: true
      }]), i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  return DaterangepickerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxDaterangepickerMd = /*#__PURE__*/(() => {
  class NgxDaterangepickerMd {
    constructor() {}
    static forRoot(config = {}, theme = {}) {
      return {
        ngModule: NgxDaterangepickerMd,
        providers: [{
          provide: LOCALE_CONFIG,
          useValue: config
        }, {
          provide: LocaleService,
          useClass: LocaleService,
          deps: [LOCALE_CONFIG]
        }, {
          provide: THEME_CONFIG,
          useValue: theme
        }, {
          provide: ThemeService,
          useClass: ThemeService,
          deps: [THEME_CONFIG]
        }]
      };
    }
    static ɵfac = function NgxDaterangepickerMd_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxDaterangepickerMd)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgxDaterangepickerMd
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DaterangepickerComponent]
    });
  }
  return NgxDaterangepickerMd;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { DaterangepickerComponent, DaterangepickerDirective, DefaultLocaleConfig, DefaultThemeConfig, LOCALE_CONFIG, LocaleService, NgxDaterangepickerMd, SideEnum, THEME_CONFIG };
